import React, { useState, useEffect, useMemo, memo } from "react";
import styled from "styled-components";
import Logo from "./assets/techno_logo_white.svg";
import useAudio from "../../hooks/useAudio";
import { colors } from "../../utils/colors";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { fetcherPickups } from "../../utils/react-query";

const queryPickupeExpressClient = new QueryClient();

function PickupExpress({ store_code }) {
  const { isLoading, error, data, refetch } = useQuery({
    queryKey: [
      `requests/pickup_express`,
      {
        store_code,
      },
    ],
    queryFn: fetcherPickups,
    refetchOnWindowFocus: true,
    refetchInterval: 30000,
  });
  console.log({ isLoading, error, data });

  const [_, toggle] = useAudio(
    `${document.location.origin}/other/knock_brush.mp3`
  );

  const values = useMemo(
    () => {
      const initialValues = {
        numbers: {},
        state: [],
      };

      if (!data) {
        return initialValues;
      }
      if (!data.success) {
        location.href = "/pickups";
        return initialValues;
      }

      initialValues["numbers"] = data.numbers;

      const rebuild_data = data.data.map((e) => {
        const time = e.seconds_before_deadline
          ? e.seconds_before_deadline + ""
          : "-1";
        const past_due = time.startsWith("-");
        const created_at = past_due ? Number(time.substr(1)) : Number(time);

        return {
          id: e.id,
          number: e.number,
          store_name: e.store_name || "",
          created_at,
          past_due,
        };
      });
      let past_due = [];
      let not_past_due = [];
      rebuild_data.forEach((e) => {
        if (e.past_due) {
          past_due.push(e);
        } else {
          not_past_due.push(e);
        }
      });
      initialValues["state"] = [
        ...past_due.sort((a, b) =>
          new Date(a.created_at).getTime() > new Date(b.created_at).getTime()
            ? 1
            : -1
        ),
        ...not_past_due.sort((a, b) =>
          new Date(a.created_at).getTime() > new Date(b.created_at).getTime()
            ? 1
            : -1
        ),
      ];

      return initialValues;
    },
    [data]
  );

  const store_name = useMemo(
    () => data?.store_name || "Visi",
    [data?.store_name]
  );
  useEffect(() => {
    document.title = `Express - ${store_name}`;
  }, [store_name]);

  useEffect(() => {
    setTimeout(() => {
      location.reload();
    }, 1000 * 60 * 60);
  }, []);

  return (
    <ExpressProvider className="col-12 vh-100 overflow-hidden">
      <div className="row">
        <div className="col-8 d-flex flex-column px-0 vh-100 overflow-auto">
          <Header>Užsakymas</Header>
          <Container className="flex-1">
            {values.state.map((e) => (
              <PickupExpressShipment key={e.id} {...e} toggle={toggle} fetchData={refetch} />
            ))}
          </Container>
        </div>
        <div className="col-4 px-0 vh-100">
          <Sidebar className="vh-100">
            <div>
              <img
                className="img-fluid my-5"
                style={{ width: "100%" }}
                src={Logo}
              />
              <InfoBlock>
                <div className="text text-success">Atiduota</div>
                <div className="text">{values.numbers?.delivered || 0}</div>
              </InfoBlock>
              <InfoBlock>
                <div className="text text-primary">Iškviestas klientas</div>
                <div className="text">{values.numbers?.client_called || 0}</div>
              </InfoBlock>
              <InfoBlock>
                <div
                  className="text"
                  style={{
                    color: colors.technorama,
                  }}
                >
                  Paruošta
                </div>
                <div className="text">{values.numbers?.ready || 0}</div>
              </InfoBlock>
              <InfoBlock>
                <div className="text text-danger">Ruošiama</div>
                <div className="text">{values.numbers?.preparing || 0}</div>
              </InfoBlock>
            </div>
            <SidebarFooter>{store_name}</SidebarFooter>
          </Sidebar>
        </div>
      </div>
    </ExpressProvider>
  );
}

const PickupExpressInitial = ({ match }) => {
  return (
    <QueryClientProvider client={queryPickupeExpressClient}>
      <PickupExpress
        store_code={match.params?.store_id?.toUpperCase() || "none"}
      />
    </QueryClientProvider>
  );
};

export default PickupExpressInitial;

const ExpressProvider = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&display=swap");
`;

const PickupExpressShipment = memo(
  ({ past_due, number, created_at, fetchData, toggle,  store_name }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      toggle()
      const intervalId = setInterval(() => {
        setCount((prevCount) => prevCount + 1);
      }, 1000);
      return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
      const total = past_due
        ? created_at + count
        : created_at > count
        ? created_at - count
        : count - created_at;
      setValue(total);
      if (total == 0) {
        fetchData();
      }
    }, [count]);
    const [value, setValue] = useState(0);

    const prettierNumber = () => {
      let time = value;
      const HOURS = Math.floor(time / 3600);
      if (HOURS > 0) {
        time = time - HOURS * 3600;
      }
      const MINUTES = Math.floor(time / 60);
      if (MINUTES > 0) {
        time = time - MINUTES * 60;
      }
      const SECONDS = time;

      return `${HOURS}:${MINUTES > 9 ? MINUTES : `0${MINUTES}`}:${
        SECONDS > 9 ? SECONDS : `0${SECONDS}`
      }`;
    };
    return (
      <ExpressChildren past_due={past_due}>
        <div className="number d-flex align-items-center">
          {number} {store_name ? ` - ${store_name}` : ""}
        </div>{" "}
        <div>
          <span className="pr-2 info">{past_due ? "Pradelsta" : "Liko"}</span>
          <span className="number">{prettierNumber()}</span>
        </div>
      </ExpressChildren>
    );
  }
);

const ExpressChildren = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 23px 33px;
  border: 1px solid ${(props) => (props.past_due ? "#FF0000" : "#FFFFFF")};
  font-family: "Noto Sans";
  font-style: normal;
  font-size: 60px;
  line-height: 82px;
  color: #ffffff;
  margin-bottom: 17px;
  .number {
    font-weight: 600;
  }
  .info {
    font-weight: 300;
    color: ${(props) => (props.past_due ? "#FF0000" : "#fff")};
  }
`;

const Header = styled.div`
  font-family: "Noto Sans";
  min-height: 132px;
  background: #f29320;
  font-weight: 600;
  font-size: 62px;
  line-height: 84.44px;
  padding: 24px 45px;
  color: #ffffff;
`;
const Container = styled.div`
  overflow-y: auto;
  background: #2b2a29;
  padding: 31px 45px;
`;

const Sidebar = styled.div`
  background: #222222;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 34px 20px;
`;

const InfoBlock = styled.div`
  background: #181818;
  // padding: 20px;
  margin-bottom: 23px;
  .text {
    font-family: "Noto Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 42px;
    line-height: 71px;
    text-align: center;
    color: #fff;
  }
`;

const SidebarFooter = styled.div`
  font-family: "Noto Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 41px;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
`;
